import React from "react";

import { useMediaQuery, useTheme, Drawer as MuiDrawer, styled } from '@mui/material';

import { useDrawerContext } from '../contexts/drawer-context';
import { MenuItemsList } from './MenuItemsList';

const StyledDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'isOpened',
})<{ isOpened: boolean }>(({ isOpened, theme }) => ({
  width: isOpened ? 280 : theme.spacing(9),
  height: '100%',
  overflow: 'auto',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.standard,
  }),
  '& .MuiDrawer-paper': {
      background: 'linear-gradient(180deg, #FFFFFF 0%, #F8FAFC 100%)',
      borderRight: '1px solid rgba(0,0,0,0.08)',
      boxShadow: '2px 0 8px rgba(0,0,0,0.05)',
      position: 'static',
      overflowX: 'hidden',
      // 为移动端菜单添加顶部间距，避免被Header覆盖
      [theme.breakpoints.down('sm')]: {
        marginTop: 0, // 移除marginTop，使用top定位
        height: 'calc(100vh - 60px)', // 设置固定高度
        position: 'fixed', // 使用固定定位
        top: '60px', // 从Header底部开始，与Header高度一致
        left: 0,
        zIndex: theme.zIndex.drawer, // 确保在Header下方
      },
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0,0,0,0.2)',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(0,0,0,0.3)',
    },
  },
}));

export const Drawer = () => {
  const { isOpened, toggleIsOpened, menu } = useDrawerContext();
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <StyledDrawer
      variant={isLargeScreen ? 'permanent' : 'temporary'}
      open={!isLargeScreen && isOpened ? true : false}
      onClose={() => toggleIsOpened(!isOpened)}
      isOpened={isOpened}
    >
      <MenuItemsList items={menu}/>
    </StyledDrawer>
  );
};
